import { Pause, Play } from 'lucide-react'

/** The visitor's way to stop background motion (WCAG 2.2.2). Pair it with `useGlobePaused`. */
export function GlobePauseButton({ paused, onToggle, className = '' }: { paused: boolean; onToggle: () => void; className?: string }) {
  return (
    <button
      type="button"
      aria-pressed={paused}
      onClick={onToggle}
      className={`inline-flex size-8 items-center justify-center rounded-md border border-border bg-card text-muted-foreground transition-colors hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring ${className}`}
    >
      {paused ? <Play className="size-4" aria-hidden="true" /> : <Pause className="size-4" aria-hidden="true" />}
      <span className="sr-only">{paused ? 'Play background animation' : 'Pause background animation'}</span>
    </button>
  )
}
